import FieldCaptionWrapper from "../../viewer/common/conditions/FieldCaptionWrapper.tsx";
import { getDateGroupingLabel } from "../../viewer/common/fields/field-captions/captionsHelper.ts";
import FieldDimensionCaption from "../../viewer/common/fields/field-captions/FieldDimensionCaption.tsx";
import type { FieldCaptionIcon } from "../../viewer/common/fields/field-captions/FieldsCaptionIconSetContainer.tsx";
import { getDimensionAggregationType } from "../../../utilities/aggregationHelper.ts";

import { dateRangeToShortString } from "../../../utilities/dateRangeToShortString.ts";
import { isDateAggregationField } from "../../../utilities/fieldsHelper.ts";
import { isReferenceDateField } from "../common/utilities/isReferenceDateField.ts";
import type { ReportField } from "../../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../../api/types/svTypes.ts";

export const formatDimensionFieldCaption = (field: ReportField) => {
  const aggregation = getDimensionAggregationType(field);
  const subCaption = isDateAggregationField(field)
    ? ""
    : aggregation
      ? dateRangeToShortString(field.config.dateRange)
      : getGroupingCaption(field);

  return <FieldCaptionWrapper Caption={<FieldDimensionCaption field={field} />} subCaption={subCaption} />;
};

export const formatDimensionInFieldsCaption = (
  field: ReportField,
  iconsSet?: FieldCaptionIcon[],
  showDateGroupingCaption = true
) => {
  const aggregation = getDimensionAggregationType(field);
  const subCaption = isDateAggregationField(field)
    ? ""
    : aggregation
      ? dateRangeToShortString(field.config.dateRange)
      : showDateGroupingCaption && isReferenceDateField(field.meta)
        ? getGroupingCaption(field)
        : "";

  return (
    <FieldCaptionWrapper
      Caption={<FieldDimensionCaption field={field} />}
      subCaption={subCaption}
      fieldCaptionIcons={iconsSet}
    />
  );
};

export const getGroupingCaption = (field: ReportField) => {
  if (field?.meta.type === ItemDataType.Date) {
    return getDateGroupingLabel(field.config.grouping);
  }
  return "";
};
